import styled from '@emotion/styled';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { color } from 'src/shared/styles/variables';

const PasswordRequirementsList = styled('ul')({
    listStyleType: 'none',
    paddingLeft: '1.25rem',
});

interface PasswordRequirementProps {
    checked?: boolean;
}

const PasswordRequirement = styled('li')<PasswordRequirementProps>(({ checked }) => ({
    display: 'block',
    position: 'relative',
    color: checked ? color.tundora : color.scorpion,
    '&:not(:last-child)': {
        marginBottom: '0.25rem',
    },
    '&:before': {
        content: '""',
        position: 'absolute',
        backgroundColor: checked ? color.scooter : color.gallery,
        width: '0.75rem',
        height: '0.75rem',
        borderRadius: '100%',
        left: '-1.25rem',
        top: 4,
    },
}));

interface Props extends WithTranslation {
    containsSpecialCharacter: boolean;
    containsNumber: boolean;
    containsUppercaseLetter: boolean;
    isLongEnough: boolean;
}

export const PasswordValidationInfo = withTranslation()(
    ({
        containsSpecialCharacter,
        containsNumber,
        containsUppercaseLetter,
        isLongEnough,
        t,
    }: Props) => (
        <PasswordRequirementsList>
            <PasswordRequirement checked={containsSpecialCharacter}>
                {t('auth:registration_form.errors.passwordSpecialCharacter')}
            </PasswordRequirement>
            <PasswordRequirement checked={containsUppercaseLetter}>
                {t('auth:registration_form.errors.passwordUppercaseLetter')}
            </PasswordRequirement>
            <PasswordRequirement checked={containsNumber}>
                {t('auth:registration_form.errors.passwordNumber')}
            </PasswordRequirement>
            <PasswordRequirement checked={isLongEnough}>
                {t('auth:registration_form.errors.passwordLength')}
            </PasswordRequirement>
        </PasswordRequirementsList>
    ),
);
